/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { ErrorType } from '../../axios';
import { request } from '../../axios';
import type { EntraIdConfigDto } from '.././model';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const getEntraIdConfig = (options?: SecondParameter<typeof request>, signal?: AbortSignal) => {
  return request<EntraIdConfigDto>({ url: `/api/config/entra-id`, method: 'GET', signal }, options);
};

export const getGetEntraIdConfigQueryKey = () => {
  return [`/api/config/entra-id`] as const;
};

export const getGetEntraIdConfigQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntraIdConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEntraIdConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntraIdConfig>>> = ({ signal }) =>
    getEntraIdConfig(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEntraIdConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntraIdConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getEntraIdConfig>>>;
export type GetEntraIdConfigQueryError = ErrorType<unknown>;

export function useGetEntraIdConfig<
  TData = Awaited<ReturnType<typeof getEntraIdConfig>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>> &
  Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>, 'initialData'>;
  request?: SecondParameter<typeof request>;
}): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEntraIdConfig<
  TData = Awaited<ReturnType<typeof getEntraIdConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>> &
  Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>, 'initialData'>;
  request?: SecondParameter<typeof request>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEntraIdConfig<
  TData = Awaited<ReturnType<typeof getEntraIdConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEntraIdConfig<
  TData = Awaited<ReturnType<typeof getEntraIdConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEntraIdConfigQueryOptions(options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetEntraIdConfigSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getEntraIdConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEntraIdConfigQueryKey();

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEntraIdConfig>>> = ({ signal }) =>
    getEntraIdConfig(requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getEntraIdConfig>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetEntraIdConfigSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getEntraIdConfig>>>;
export type GetEntraIdConfigSuspenseQueryError = ErrorType<unknown>;

export function useGetEntraIdConfigSuspense<
  TData = Awaited<ReturnType<typeof getEntraIdConfig>>,
  TError = ErrorType<unknown>,
>(options: {
  query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEntraIdConfigSuspense<
  TData = Awaited<ReturnType<typeof getEntraIdConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetEntraIdConfigSuspense<
  TData = Awaited<ReturnType<typeof getEntraIdConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetEntraIdConfigSuspense<
  TData = Awaited<ReturnType<typeof getEntraIdConfig>>,
  TError = ErrorType<unknown>,
>(options?: {
  query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getEntraIdConfig>>, TError, TData>>;
  request?: SecondParameter<typeof request>;
}): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetEntraIdConfigSuspenseQueryOptions(options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
